export const GetAllInstructors = `
  {
    Mentor(
      orderby: POSITION_ASC,
      availabletowork: INDIFFERENT,     
      onlywithposts: YES,
    ){
      pageCount
      mentors {
        uid      
        alias
        profilepicture

        relatedmedia{
          render
  
          imagesettings {
            imagesettingid
            width
            height
            waspectratio
            haspectratio
            xcenter
            ycenter
          }
  
          mediacontenttype {
            internalname
          }
        }
      }
    }
  }
`;
